        
    import { useState, useEffect } from "react";
    import {
      Popover,
      PopoverButton,
      PopoverGroup,
      PopoverPanel,
    } from "@headlessui/react";
    import {
      Bars3Icon,
      ChevronDownIcon,
      XMarkIcon,
    } from "@heroicons/react/24/outline";



const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  // Handle scroll effect
  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 10);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);




  const company = [
    {
      name: "About us",
      description: "Learn about our mission and values",
      href: "/AboutUs",
    },
    {
      name: "Contact Us",
      description: "Join our Platfom",
      href: "/ContactUs",
    },
    {
      name: "News",
      description: "Stay updated with our latest announcements",
      href: "/News",
    },
  ];
  return (
    <>
    


    


      <header
        className={` fixed w-full top-0 z-50 transition-all duration-300 ${
          scrolled
            ? "bg-gradient-to-r from-[#263283] to-[#ed2924] text-white backdrop-blur-md shadow-lg py-2  "
            : "bg-transparent py-4 text-white"
        }`}
      >
        <nav
          aria-label="Global"
          className="mx-auto flex  justify-between items-center  px-6 lg:px-12"
        >
          {/* Logo */}
          <div className="flex item-center  gap-20">
            <div className="flex justify-center ">
              <a
                href="#"
                className="flex items-center space-x-2 transition duration-300 ease-in-out hover:opacity-80"
              >
                <div className=" p-2 ">
                  <img
                    alt="adtofuture"
                    src="/gfmlogo.png"
                    className="h-auto w-16  bg-transparent items-center  flex "
                  />
                </div>
              </a>
            </div>
           
          </div>
          <PopoverGroup className="hidden justify-center lg:flex lg:gap-x-8 lg:items-center">
              <a
                href="/"
                className="text-lg   
            transition duration-300 ease-in-out"
              >
                Home
              </a>
              <a
                href="/about"
                className="text-lg   
            transition duration-300 ease-in-out"
              >
                About Us
              </a>
           

             
              <a
                href="/Service"
                className="text-lg   
            transition duration-300 ease-in-out"
              >
                Service
              </a>
              <a
                href="/contact"
                className="text-lg   
            transition duration-300 ease-in-out"
              >
                Contact
              </a>

            
            </PopoverGroup>
          {/* Mobile menu button */}
          <div className="flex lg:hidden">
            <button
              type="button"
              onClick={() => setMobileMenuOpen(true)}
              className="inline-flex items-center rounded-full p-2 
              text-gray-600 bg-white/80 backdrop-blur-sm shadow-sm border border-gray-200
              hover:bg-indigo-50  transition duration-300 ease-in-out"
            >
              <span className="sr-only">Open main menu</span>
              <Bars3Icon aria-hidden="true" className="size-5" />
            </button>
          </div>

          {/* Desktop navigation */}

          {/* Login buttons */}
          <div className="hidden lg:flex  lg:justify-end lg:gap-x-4 lg:items-center">
            <a
              href="/user/login"
              className="text-lg font-mediumtext-gray-600  
            transition duration-300 ease-in-out"
            >
              Log in
            </a>
            <a
              href="/registration"
              className="inline-flex rounded-xl items-center justify-center  bg-gray-200 
            px-4 py-2 text-lg text-red-500 font-semibold shadow-sm hover:shadow-lg hover:text-gray-600 
            "
            >
              Signup
            </a>
          </div>
        </nav>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="fixed inset-0 z-50">
            <div className=" inset-y-0 right-0 z-50 w-full overflow-y-auto bg-gradient-to-r from-[#263283] to-[#ed2924] sm:max-w-sm sm:ring-1 sm:ring-gray-100/10">
              <div className="flex items-center justify-between px-6 py-6">
                <a href="#" className="flex items-center space-x-2">
                  <div className="  ">
                    <img
                      alt="adtofuture"
                      src="/gfmlogo.png"
                      className="h-auto w-12"
                    />
                  </div>
                </a>
                <button
                  type="button"
                  onClick={() => setMobileMenuOpen(false)}
                  className="rounded-full p-2 text-gray-600 bg-gray-100 hover:bg-gray-200"
                >
                  <span className="sr-only">Close menu</span>
                  <XMarkIcon className="size-5" aria-hidden="true" />
                </button>
              </div>
              <div className=" divide-y divide-gray-100  text-white px-6 py-4 space-y-2">
                <a
                  href="/"
                  className="text-lg   
            transition duration-300 ease-in-out"
                >
                  Home
                </a>
                <div className="py-4">
                
                    <a
                      href="/about"
                      className="text-lg   
            transition duration-300 ease-in-out"
                    >
                      About US
                    </a>
             
                  {/* <div className="space-y-1">
                    <a
                      href="/Blogs"
                      className="text-lg   
            transition duration-300 ease-in-out"
                    >
                      Blogs
                    </a>
                  </div> */}
                </div>
                <div className="py-4">
                  <div className="space-y-4">
                    {/* <a
                      href="/Career"
                      className="text-lg   
            transition duration-300 ease-in-out"
                    >
                      Career
                    </a> */}

                    {/* {company.map((item) => (
                      <a
                        key={item.name}
                        href={item.href}
                        className="block py-2 text-lg text-gray-100 "
                      >
                        {item.name}
                      </a>
                    ))} */}
                  </div>
                  <div className="space-y-4 flex flex-col">
                  <a
                href="/Service"
                className="text-lg   
            transition duration-300 ease-in-out"
              >
                Service
              </a>
              <a
                href="/contact"
                className="text-lg   
            transition duration-300 ease-in-out"
              >
                Contact
              </a>
                  
                  </div>
                </div>
                <div className="py-6 space-y-4">
                  <a
                    href="/user/login"
                    className="block text-center w-full rounded-md bg-white px-3 py-2 text-base 
                    text-red-600 hover:bg-indigo-50 border border-red-600 shadow-sm"
                  >
                    Log in
                  </a>
                  <a
                    href="/registration"
                    className="block text-center w-full rounded-md bg-gradient-to-r from-[#1a204a] to-[#61100f] 
                    px-3 py-2.5 text-base text-white shadow-sm hover:from-orange-500 hover:to-orange-800"
                  >
                    Sign up
                  </a>
                </div>
              </div>
            </div>
          </div>
        )}
      </header>
   

    
    
    </>
  )
}

export default Header